import React, { useState, useEffect } from "react";
import { toast } from "../../../../components/toastNotification";
import TextInput from "../../../../components/TextInput";
import { useRecoilState } from "recoil";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import ChannelForm from "./ChannelForm";
import AddButton from "../../../../components/AddButton";

import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";

import useChannel from "./hooks/useChannel";
import useDeleteChannel from "./hooks/useDeleteChannel";
import useUpdateChannel from "./hooks/useUpdateChannel";
import {
  addStateChannel,
  selectedRowsStateChannel,
  setFilterTextChannel,
} from "./atoms/atoms";
import TableFilters from "../TableFilters";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";
import EditButton from "../../../../components/EditButton";
import { useQueryClient } from "react-query";
import MaterialOfficeConfigTable from "../../../../components/tables/MaterialOfficeConfigTable";

const ChannelTable = () => {
  //Hooks Call
  const { data, isFetching } = useChannel();
  const { mutateAsync: UpdateChannel } = useUpdateChannel();
  const BulkDeleteChannel = useDeleteChannel();
  //Atoms Call
  const [actionAddState, setActionAddState] = useRecoilState(addStateChannel);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateChannel
  );
  const [filterText, setFilterText] = useRecoilState(setFilterTextChannel);
  //Local States
  const [rowsCount, setRowsCount] = useState(0);
  const [editRowId, setEditRowId] = useState(null);
  const [edit, setEdit] = useState(false);
  const [actionEditState, setActionEditState] = useState(false);
  const [, setEmpTypeIsExistState] = useState(false);
  const [empTypeDataIsChange, setEmpTypeDataIsChange] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [haschannelType, setHaschannelType] = useState(true);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [displayNote] = useState(false);
  const [hideColumn, sethideColumn] = useState(false);
  const [channelFilteredData, setChannelFilteredData] = useState([]);
  const queryClient = useQueryClient();
  const [editRowData, setEditRowData] = useState();

  const addPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_channel_add;
  const editPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_channel_edit;
  const deletePermission =
    PERMISSIONS.permission_utilities_officeconfiguration_channel_delete;

  const userPermissions = useRecoilValue(permissionsSelector);

  const defaultValues = {
    channelId: 0,
    channelName: "",
    isActive: true,
    createdBy: "",
    createdOn: null,
  };
  const [empNewData, setNewData] = useState([defaultValues]);
  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }
  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setChannelFilteredData(result);
          setChannelId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {
        //console.log("error " + error);
      }
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  useEffect(() => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    setActionAddState(false);
    setActionEditState(false);
    setSelectedRows([]);
    setEditRowId([]);
  }, []);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleCheckBox = (checked) => {
    setEmpTypeDataIsChange(true);
    checked ? setCheckStatus(true) : setCheckStatus(false);
    checked
      ? empNewData.map((x) => (x.isActive = true))
      : empNewData.map((x) => (x.isActive = false));
  };

  const handleEditFieldsChange = (SourceType, fieldName, row, inputvalue) => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    inputvalue = inputvalue.trim();
    if (SourceType === "channelType") {
      if (fieldName === "channelName") {
        setEmpTypeDataIsChange(true);
        empNewData.map((x) => (x.channelName = inputvalue));
      }
      inputvalue === "" ? setHaschannelType(false) : setHaschannelType(true);
    }
  };

  const handleEditButton = (rowData) => {
    setEditRowId(rowData.channelId);
    setEmpTypeDataIsChange(false);
    setEdit(true);
    setCheckStatus(rowData.isActive);
    setEditRowData({ ...rowData });
    empNewData.map((x) => (x.channelId = rowData.channelId));
    empNewData.map((x) => (x.channelName = rowData.channelName));
    empNewData.map((x) => (x.isActive = rowData.isActive));
    empNewData.map((x) => (x.createdBy = rowData.createdBy));
    empNewData.map((x) => (x.createdOn = rowData.createdOn));
  };

  //Save changes
  const handleSave = (empNewData) => {
    setOpenModalEdit(false);
    if (actionEditState) {
      UpdateChannel(empNewData, {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "The data already exists!", "error");
            setOpenModalEdit(false);
          } else if (
            empNewData[0]?.channelName === editRowData.channelName &&
            empNewData[0]?.isActive === editRowData.isActive
          ) {
            toast.fire("Saving Failed", "No Changes have been made", "warning");
            setOpenModalEdit(false);
          } else {
            setNewData([defaultValues]);
            setEditRowId([]);
            setSelectedRows([]);
            setOpenModalEdit(false);
            setActionEditState(false);
            setDisabledButton(false);
            sethideColumn(false);
            setEdit(false);
            queryClient.invalidateQueries(["GetChannels"]);
            toast.fire("Success", "Channel Updated Successfully", "success");
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Update Channel", "error");
          queryClient.invalidateQueries(["GetChannels"]);
          setOpenModalEdit(false);
        },
      });
    }
  };
  // end of saving changes

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.channelId);
    BulkDeleteChannel(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Channels" : "Channel"
    }?`}</div>
  );

  const matColumns = [
    {
      title: "Channel Name",
      field: "channelName",
      customSort: (a, b) =>
        a.channelName && b.channelName
          ? a.channelName.trim().localeCompare(b.channelName.trim())
          : a.channelName
          ? 0
          : -1,
      render: (rowData) => {
        return rowData.channelId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="Channel Name"
              defaultValue={rowData.channelName}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "channelType",
                  "channelName",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
          </div>
        ) : (
          <>{rowData.channelName}</>
        );
      },
    },
    {
      title: "Created By",
      field: "createdBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.createdBy}</>
        );
      },
    },
    {
      title: "Created Date",
      field: "createdOn",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : rowData.createdOn ? (
          new Date(rowData.createdOn).toLocaleDateString()
        ) : (
          ""
        );
      },
    },
    {
      title: "Modified Date",
      field: "modifiedDate",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : rowData.modifiedDate ? (
          new Date(rowData.modifiedDate).toLocaleDateString()
        ) : (
          ""
        );
      },
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.modifiedBy}</>
        );
      },
    },

    {
      title: "Status",
      field: "isActive",
      align: "left",
      render: (rowData) => {
        return rowData.channelId === editRowId ? (
          <div className="flex justify-start space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handleCheckBox(e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {checkStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      render: (rowData) => {
        return !userPermissions.includes(editPermission) ? (
          ""
        ) : rowData.channelId === editRowId ? (
          <div className="flex place-content-center  gap-1">
            <SaveButton
              className={`flex shadow-md text-xs font-semibold text-white  gap-x-1 rounded-full  bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
            ${
              !haschannelType || !empTypeDataIsChange
                ? "opacity-50"
                : "opactiy-100"
            }`}
              disabled={!haschannelType || !empTypeDataIsChange}
              onClick={() => {
                setOpenModalEdit(true);
              }}
            />
            <CancelButton
              className="flex text-xs shadow-md font-semibold text-white ml-1 gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70"
              onClick={() => {
                setActionEditState(false);
                setEditRowId([]);
                setEmpTypeDataIsChange(false);
                setEmpTypeIsExistState(false);
                setDisabledButton(false);
                setEdit(false);
                sethideColumn(false);
              }}
            />
          </div>
        ) : (
          <div className="flex items-center place-content-center mr-5">
            <EditButton
              disabled={disabledButton || selectedRows.length > 0}
              className={
                disabledButton || selectedRows.length > 0
                  ? "opacity-50 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
                  : "opacity-100 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
              }
              onClick={() => {
                setDisabledButton(true);
                setActionEditState(true);
                handleEditButton(rowData);
                setEdit(true);
                sethideColumn(true);
              }}
            />
          </div>
        );
      },
    },
  ];

  //Filters
  const [channelId, setChannelId] = useState("");
  useEffect(() => {
    if (filterText) {
      setChannelFilteredData(
        data?.filter((x) =>
          x.channelName
            ?.toLowerCase()
            .includes(filterText.trim()?.toLowerCase())
        )
      );
    } else if (channelId?.includes(".")) {
      let channelIds = channelId.split(".");
      const channelIdsArr = channelIds.map((id) => Number(id));
      const filteredData = data?.filter((x) =>
        channelIdsArr.includes(x.channelId)
      );

      setChannelFilteredData(filteredData);
    } else {
      const filteredData = data?.filter(
        (x) => x.channelId === Number(channelId)
      );
      setChannelFilteredData(filteredData);
    }
  }, [filterText, data]);

  return (
    <div className="animate-fade-in-down w-full">
      {actionAddState ? (
        ""
      ) : (
        <div className="font-bold text-primary text-xl uppercase ">
          {" "}
          {/* <h1> Channel</h1>{" "} */}
        </div>
      )}
      {!actionAddState && (
        <div className="">
          <div className="flex w-full">
            <div className="bg-white w-full p-4">
              <div className="flex flex-row justify-between items-center">
                <div className="">
                  <TableFilters
                    filterText={setFilterText}
                    moduleDetails="Channel Name"
                    textInputName="channelName"
                    disabledButton={disabledButton || selectedRows.length > 0}
                  ></TableFilters>
                </div>
                <div className="">
                  {userPermissions.includes(addPermission) ? (
                    <AddButton
                      buttonText="New Channel"
                      className={
                        selectedRows.length > 0 || actionEditState
                          ? "opacity-50"
                          : "opacity-100"
                      }
                      onClick={() => setActionAddState(!actionAddState)}
                      disabled={disabledButton || selectedRows.length > 0}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {userPermissions.includes(deletePermission) ? (
                <div className="text-secondary italic text-xs3 my-2">
                  <p className="font-bold italic inline-block mr-1">Note:</p>
                  <span>Tick the box to deactivate some data.</span>
                </div>
              ) : (
                <div className="mb-4"></div>
              )}
              <div className="">
                <MaterialOfficeConfigTable
                  columns={matColumns}
                  data={
                    channelFilteredData?.length > 0
                      ? channelFilteredData
                      : data
                      ? filterText === ""
                        ? data
                        : channelFilteredData
                      : []
                  }
                  options={{
                    toolbar: false,
                    showTitle: false,
                  }}
                  selection={
                    !actionEditState &&
                    userPermissions.includes(deletePermission)
                  }
                  setOpenModal={setOpenModalDelete}
                  onSelectionChange={handleSelectedRowsChange}
                  selectedRows={selectedRows}
                  isDeactivate={true}
                  isLoading={isFetching}
                />
              </div>
            </div>
          </div>
          <ConfirmBoxModal
            ModalTitle="Update Channel"
            qConfirmation=" Are you sure you want to update this?"
            isOpen={openModalEdit}
            onClose={() => {
              setOpenModalEdit(false);
              sethideColumn(true);
            }}
            onClickFunction={() => {
              handleSave(empNewData);
            }}
          />
          <ConfirmBoxDelete
            ModalTitle="Deactivate Channel"
            qConfirmation={deleteMessage}
            isOpen={openModalDelete}
            onClose={() => setOpenModalDelete(false)}
            onClickFunction={
              isBulkSelected ? handleBulkDelete : handleBulkDelete
            }
          />
        </div>
      )}
      {actionAddState && (
        <div className="p-4">
          <ChannelForm />
        </div>
      )}
      {/* </div> */}
    </div>
  );
};

export default ChannelTable;
